<template>
  <div class="loader" />
</template>

<script>
export default {
  name: 'Spinner'
}
</script>

<style lang="scss">
@use '@/../static/stylesheets/variables' as *;

  .loader,
  .loader:after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }
  .loader {
    margin: 0 auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid rgba(127,26,84, 0.2);
    border-right: 1.1em solid rgba(127,26,84, 0.2);
    border-bottom: 1.1em solid rgba(127,26,84, 0.2);
    border-left: 1.1em solid $brand-primary;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 0.4s infinite linear;
    animation: load8 0.4s infinite linear;
    &.small {
      border-width: 3px;
      width: 2em;
      height: 2em;
    }
    &.medium {
      border-width: 4px;
      width: 4em;
      height: 4em;
    }

  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
